/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is equivalent weight?`)
};

const es_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué es el peso equivalente?`)
};

const de_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist das Äquivalentgewicht?`)
};

const nl_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is equivalentgewicht?`)
};

const fr_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que l'équivalent-gramme ?`)
};

const it_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cos'è il peso equivalente?`)
};

const pt_br2_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é peso equivalente?`)
};

const pt_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é o equivalente-grama?`)
};

const ja_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量とは何ですか？`)
};

const zh_norm_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是当量重量？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_q2", locale)
	if (locale === "en") return en_norm_faq_q2(inputs)
	if (locale === "es") return es_norm_faq_q2(inputs)
	if (locale === "de") return de_norm_faq_q2(inputs)
	if (locale === "nl") return nl_norm_faq_q2(inputs)
	if (locale === "fr") return fr_norm_faq_q2(inputs)
	if (locale === "it") return it_norm_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_q2(inputs)
	if (locale === "pt") return pt_norm_faq_q2(inputs)
	if (locale === "ja") return ja_norm_faq_q2(inputs)
	return zh_norm_faq_q2(inputs)
};